import { useState, useEffect } from "react";

import { Grid, TextField } from "@mui/material";

import { request } from "@/Api";
import {
    AccountSectionRow,
    AccountSubtitle,
    AccountInput,
} from "@/account/StyledComponents";
import { SectionEdit } from "@/account/CommonComponents";
import ConfirmPassword from "@/auth/ConfirmPassword";

export default function ContactSection({
    data,
    warning,
    disableEdit,
    setSaved,
    setError,
    setData,
}) {
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [email, setEmail] = useState(data.email);

    const handleEdit = () => {
        setEditing(true);
        setEmail(data.email);
    };

    const handleSave = () => {
        setError("");
        setLoading(true);

        request
            .patch("account", { email })
            .then((response) => {
                setEditing(false);
                setData({
                    ...data,
                    email: response.data.email,
                });
                setSaved(true);
            })
            .catch((error) => {
                const msg = Array.isArray(error.response.data.detail)
                    ? error.response.data.detail.map((e) => e.msg).join(", ")
                    : error.response.data.detail;
                setError(msg || "Failed to save");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setEditing(false);
        setEmail(data.email);
    };

    useEffect(() => {
        setEmail(data.email);
    }, [data]);

    return (
        <Grid item>
            <SectionEdit
                title="Contact Info"
                editing={editing}
                loading={loading}
                handleEdit={() => setConfirming(true)}
                handleSave={handleSave}
                handleCancel={handleCancel}
                warning={warning}
                disableEdit={disableEdit}
            />
            <AccountSectionRow>
                <AccountSubtitle>Email</AccountSubtitle>
                <AccountInput>
                    {editing ? (
                        <TextField
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            type="email"
                            required
                            variant="filled"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                            }}
                        />
                    ) : (
                        <p>{data.email}</p>
                    )}
                </AccountInput>
            </AccountSectionRow>

            <ConfirmPassword
                open={confirming}
                setOpen={setConfirming}
                successCallback={() => setEditing(true)}
                email={data.email}
            />
        </Grid>
    );
}
